import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import useRetryFetch from "./useRetryFetch";
import { listPwfs } from "../api/pwf";
import { readRituals, type RitualDay } from "../lib/rituals";

/** Ritual prefs + log from the compass (same ["cockpit-projects"] cache as the rest of Today). */
export function useRitualDay(enabled = true): RitualDay & { ready: boolean } {
  const retryFetch = useRetryFetch();
  const { data, isFetched, isError } = useQuery({
    queryKey: ["cockpit-projects"],
    queryFn: () => listPwfs(retryFetch),
    staleTime: 30_000,
    enabled,
  });
  const day = useMemo(() => readRituals(data ?? []), [data]);
  return { ...day, ready: isFetched || isError };
}
